import React, { Component } from 'react';
import _ from 'lodash';
import DisableNextModal from '../../../shared/Common/disableNextModal';
import SizeTabs from './SizeTabs/SizeTabs'

class ValidationMatrix extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            tabs: []
        };
    }
    componentWillMount() {
        let body = {
            projectId: this.props.projectId,
            type: "segmentation"
        }
        let data = {
            projectId: this.props.projectId,
            type: "benefitsLadder"
        }
        this.props.getSegmentation(body)
        this.props.getBenefitsLadder(data)
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.segmentation.editData !== nextProps.segmentation.editData) {
            let body = {
                projectId: this.props.projectId,
                type: "segmentation"
            }
            let data = {
                projectId: this.props.projectId,
                type: "benefitsLadder"
            }
            this.props.getSegmentation(body)
            this.props.getBenefitsLadder(data)
        }
        if (this.props.segmentation.segmentationData !== nextProps.segmentation.segmentationData && nextProps.segmentation.segmentationFetched && nextProps.segmentation.editFetched) {
            this.setState({
                segmentation: nextProps.segmentation.segmentationData.Items[0],
                benefits: nextProps.benefits.benefitsLadderData.Items[0].data,
            })
        }
    }
    onPercentChange = (e, groupId) => {
        let tabs = this.state.tabs
        tabs.map(tab => {
            if (tab.groupId === groupId) {
                tab.segments.map(segment => {
                    if (segment.segmentId === e.target.id) {
                        segment.percent = +e.target.value
                    }
                })
            }
        })
        this.setState({ tabs })
    }
    checkValid = () => {
        for (let i in this.state.tabs) {
            var percent = 0
            for (let j in this.state.tabs[i].segments) {
                percent += this.state.tabs[i].segments[j].percent
            }
            if (percent !== 100) {
                return true
            }
        }
    }
    nextLevel = () => {
        let segments = [];
        this.state.tabs.map(item => {
            segments.push(...item.segments);
        })
        let body = {
            type: "segmentation",
            projectId: this.props.projectId,
            id: this.props.segmentation.segmentationData.Items[0].id,
            segments: segments,
            status: 'finished',
        }
        if (this.checkValid()) {
            this.props.disableNextModal();
        } else {
            this.props.editSegmentation(body)
            this.props.groupStateNext()
        }
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {
        if (this.props.segmentation.editFetched && this.props.segmentation.segmentationFetched && this.props.benefits.benefitsLadderFetched && this.state.tabs.length === 0 && this.state.segmentation) {
            let tabs = [];
            let segments = [...this.state.segmentation.segments];
            let benefits = [...this.state.benefits];
            let groups = _.uniqBy(this.state.segmentation.segments, "groupId");
            benefits.map(benefit => {
                groups.map(group => {
                    if (benefit.groupId === group.groupId) {
                        tabs.push({
                            groupName: benefit.groupName,
                            groupId: group.groupId,
                            segments: _.filter(segments, (o) => { return o.groupId === group.groupId }),
                        })
                    }
                })
            })
            this.setState({ tabs })
        }
        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-three arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-three arrow-step active-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-three arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                {(!this.props.segmentation.segmentationFetching && !this.props.benefits.benefitsLadderFetching && !this.props.segmentation.editFetching) && <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>SEGMENTATION</h5>
                      </div>
                    </div>
                    <div className='row'>
                        <div className='col-xl-6 col-lg-7 col-md-8'>
                            <div className='card'>
                                <div className='card-header'>
                                    <h5>Segment Sizing</h5>
                                    <span>Estimate the size of each segment by expressing each as a percentage of 100</span>
                                </div>
                                <div className='card-body'>
                                    <SizeTabs
                                        tabs={this.state.tabs}
                                        onPercentChange={this.onPercentChange}
                                        tabStep={this.props.tabStep}
                                        onTabChange={this.props.onTabChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div onClick={this.nextLevel} className='btn btn-success'> Next </div>
                                    <div className='btn empty-btn default' onClick={this.props.groupStateBack}> Back </div >
                                </div>
                            </div>
                        </div>

                    </div>
                </div>}
                {(this.props.segmentation.segmentationFetching || this.props.benefits.benefitsLadderFetching || this.props.segmentation.editFetching) &&
                    <div className='card'>
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    </div>
                }
                {this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText="Each group's segment weights must equal 100"
                        disableModalTitle='Notice'
                    />

                }
            </div>
        )
    }
}

export default (ValidationMatrix);



// WEBPACK FOOTER //
// ./src/components/Segmentation/SegmentSize/SegmentSize.jsx